import * as types from './types';

export const getCurrentNote = ({ variables }) => {
  return {
    type: types.GET_CURRENT_NOTE,
    payload: variables,
  };
};

export const blockCurrentNote = ({ variables }) => {
  return {
    type: types.BLOCK_NOTE,
    payload: variables,
  };
};

export const unBlockCurrentNote = ({ variables }) => {
  return {
    type: types.UNBLOCK_NOTE,
    payload: variables,
  };
};

export const fileUpload = ({ variables }) => {
  return {
    type: types.NOTE_FILE_UPLOAD,
    payload: variables,
  };
};

export const fileRemove = ({ variables }) => {
  return {
    type: types.NOTE_FILE_REMOVE,
    payload: variables,
  };
};

export const templateFileRemove = ({ variables }) => {
  return {
    type: types.NOTE_TEMPLATE_FILE_REMOVE,
    payload: variables,
  };
};

export const createNote = ({ variables }) => {
  return {
    type: types.CREATE_NOTE,
    payload: variables,
  };
};

export const duplicateNote = ({ variables }) => {
  return {
    type: types.DUPLICATE_NOTE,
    payload: variables,
  };
};

export const updateSingleNote = (payload) => {
  return {
    type: types.UPDATE_NOTE,
    payload,
  };
};

export const updateNoteContent = (payload) => {
  return {
    type: types.UPDATE_NOTE_CONTENT,
    payload,
  };
};

export const pushNoteChange = (payload) => {
  return {
    type: types.PUSH_NOTE_CHANGE,
    payload,
  };
};

export const deleteNote = (payload) => {
  return {
    type: types.DELETE_NOTE,
    payload,
  };
};

export const downloadStart = ({ variables }) => {
  return {
    type: types.DOWNLOAD_START,
    payload: variables,
  };
};

export const getNoteBlockedStatus = ({ variables }) => {
  return {
    type: types.GET_NOTE_BLOCKED_STATUS,
    payload: variables,
  };
};

export const downloadSuccess = ({ variables }) => {
  return {
    type: types.DOWNLOAD_SUCCESS,
    payload: variables,
  };
};

export const downloadFail = ({ variables }) => {
  return {
    type: types.DOWNLOAD_FAIL,
    payload: variables,
  };
};

export const closeErrorModal = () => {
  return {
    type: types.NOTE_ERROR_MODAL_CLOSE,
  };
};

export const getCurrentTemplate = ({ variables }) => {
  return {
    type: types.GET_CURRENT_TEMPLATE,
    payload: variables,
  };
};

export const createTemplate = ({ variables }) => {
  return {
    type: types.CREATE_TEMPLATE,
    payload: variables,
  };
};

export const duplicateTemplate = ({ variables }) => {
  return {
    type: types.DUPLICATE_TEMPLATE,
    payload: variables,
  };
};

export const updateSingleTemplate = (payload) => {
  return {
    type: types.UPDATE_TEMPLATE,
    payload,
  };
};

export const updateTemplateContent = (payload) => {
  return {
    type: types.UPDATE_TEMPLATE_CONTENT,
    payload,
  };
};

export const pushNoteTemplateChange = (payload) => {
  return {
    type: types.PUSH_NOTE_TEMPLATE_CHANGE,
    payload,
  };
};

export const deleteTemplate = (payload) => {
  return {
    type: types.DELETE_TEMPLATE,
    payload,
  };
};

export const updateUseFileUpload = (payload) => {
  return {
    type: types.UPDATE_USE_FILE_UPLOAD,
    payload,
  };
};

export const restrictionsNote = (payload) => {
  return {
    type: types.RESTRICTIONS_NOTE,
    payload,
  };
};
